/** @jsx jsx */
import { jsx, Flex, Box, Styled } from "theme-ui"
import Accordion from "./accordion"
import Img from "gatsby-image"

export default ({ title, description, image }) => (
  <Accordion
    title={title}
    content={
      <Flex
        sx={{ flexDirection: "column", pt: 2, pb: 4, alignItems: "center" }}
      >
        <Styled.p>{description}</Styled.p>
        {image && (
          <Box sx={{ width: "100%", my: 3 }}>
            <Img
              fluid={image.childImageSharp.fluid}
              alt={`${title} (Lotta Vuorma)`}
            />
          </Box>
        )}
      </Flex>
    }
  />
)
